<template>
  <div>
    <div class="row dashboard-title">Reporte de </div>
    <div class="row justify-content-md-center dashboard-welcome mb-1">
      <div class="text-center">
        Bienvenido
        <br />
        {{ userName }}
      </div>
    </div>
    <div class="balance-card">
      <div class="row">
        <div class="col-sm-12">
          <div class="balance-date">
            <div class="report-container">Reporte</div>
            <div class="month-container">
              <multiselect
                v-model="value"
                :options="monthNames"
                :searchable="true"
                :close-on-select="true"
                @input="onChange"
                :allow-empty="false"
                :show-labels="false"
                placeholder="Mes"
                track-by="month"
                label="month"
                required
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 balance-label">
          <b>{{ tatal_advancement_give }}</b>  Otorgados
          <br />
          <b>{{ totalCancel }}</b>  Rechazados
        </div>
        <div class="col-sm-6 balance-amount text-right">
          {{ balance | formatNumberCurrency }} M/N
          <br />
          <h6 style="color: #a8a8a8">Saldo al corte</h6>
        </div>
      </div>
    </div>
    <div class="container" v-if="!nodata">
      <div class="col-md-12">
        <carousel
          :per-page="4"
          :mouse-drag="false"
          :pagginationPadding="5"
          :per-page-custom="[[20, 1], [480, 1], [850, 2], [1200, 4]]"
          paginationActiveColor="#4E3593"
          paginationColor="#ACADAE"
          class
        >
          <slide v-for="chart in charts" :key="chart.id" style="height: 100%; width: 100%;">
            <div class="justify-content-md-center graphics">
              <div class="col-sm-10">
                <charts
                  :chart-data="{
                  labels: [chart.sublabel, chart.compareLavel],
                  datasets: [
                    {
                      backgroundColor: [chart.color, '#F0F0F0'],
                      borderWidth: 0,
                      hoverBorderWidth: 0,
                      data: [chart.totalStatus, (chart.totalCompare - chart.totalStatus)]
                    }
                  ]
                }"
                ></charts>
                <b>$ {{ chart.balanceStatus | formatNumberCurrency }}</b>
                <br />
                <label :class="chart.class">{{ chart.label }}</label>
                <br />
                <span>{{ chart.description }}</span>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
      <hr
        style="margin-top: 0.5rem; margin-bottom: 0.5rem;"
        v-if="$can('read', 'ResumeMetricsUtility')"
      />
      <div class="col-md-12" v-if="$can('read', 'ResumeMetricsUtility')">
        <div class="row dashboard-title mb-2">Meta del mes</div>
        <div v-if="metricType !== ''">
          <div class="row">
            <div class="col-sm-12 mb-2">
              Meta calculada en referencia a
              <b>{{ metricType }}</b>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 mb-2 text-center">
              <h5 v-if="tatal_compare <= 100">{{ tatal_compare | formatNumberCurrency }}%</h5>
              <h5 v-else>
                100%
                <br />Meta cumplida !!!
              </h5>
            </div>
          </div>
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped bg-success"
              role="progressbar"
              :style="'width:' + tatal_compare + '%'"
              aria-valuemin="0"
              :aria-valuemax="metricAmount"
            ></div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              progreso: ${{ progress | formatNumberCurrency }}
              <br />
              <span v-if="tatal_compare >= 100">{{ tatal_compare | formatNumberCurrency }}%</span>
            </div>
            <div class="col-sm-6 text-right">meta: ${{ metricAmount | formatNumberCurrency }}</div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-sm-12 text-center">
              Aún no existe una meta para este mes,
              <router-link to="/principal/metrics/utility">ir a crearla</router-link>
            </div>
          </div>
        </div>
      </div>
      <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;" />
      <div class="col-md-12" v-if="$can('read', 'ResemeUtils')">
        <div class="row dashboard-title">Indicadores de utilidad</div>
        <div class="container">
          <div class="row">
            <div v-for="chart in chartsutils" :key="chart.id" class="col-md-6 mb-4">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <charts
                        :height="100"
                        :chart-data="{
                          labels: [chart.labelChars, 'Totales'],
                          datasets: [
                            {
                              backgroundColor: [chart.color, '#F0F0F0'],
                              borderWidth: 0,
                              hoverBorderWidth: 0,
                              data: [chart.totalStatus, chart.comparetotalStatus]
                            }
                          ]
                        }"
                      ></charts>
                    </div>
                    <div class="col-md-8">
                      <h5 class="card-title">{{ chart.label }}</h5>
                      <p class="card-text">
                        Monto:
                        <b>$ {{ chart.balanceStatus | formatNumberCurrency }}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-5" v-else>
      <div class="row">
        <div class="col-sm-12 text-center nodata-alert">Sin adelantos en este mes.</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axiosAdelaService from '@/axios/axiosAdelaService'
import Charts from './Charts.vue'

export default {
  components: { Charts },
  data () {
    return {
      metricAmount: 0,
      metricType: '',
      totalCancel: 0,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      balance: 0,
      tatal_advancement: 0,
      tatal_advancement_give: 0,
      tatal_compare: 0,
      progress: 0,
      charts: [],
      value: { value: '', month: '' },
      nodata: false,
      chartsutils: [],
      monthNames: [
        { value: 0, month: 'Enero' },
        { value: 1, month: 'Febrero' },
        { value: 2, month: 'Marzo' },
        { value: 3, month: 'Abril' },
        { value: 4, month: 'Mayo' },
        { value: 5, month: 'Junio' },
        { value: 6, month: 'Julio' },
        { value: 7, month: 'Agosto' },
        { value: 8, month: 'Septiembre' },
        { value: 9, month: 'Octubre' },
        { value: 10, month: 'Noviembre' },
        { value: 11, month: 'Diciembre' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    userName () {
      return `${this.user.name} ${this.user.last_name_1}`
    }
  },
  methods: {
    async TotalMonth () {
      this.value = this.monthNames[this.month]
      try {
        const request = {
          Month: this.month + 1,
          Year: this.year
        }
        const metric = await axiosAdelaService.post('/getMonthMetricsUtility', JSON.stringify(request))
        if (metric.status === 200 && metric.data.length > 0) {
          this.metricAmount = metric.data[0].amount
          this.metricType = metric.data[0].type
        }
        const response = await axiosAdelaService.post('/getIndicatorsMonth', JSON.stringify(request))
        if (response.status === 200) {
          if (response.data[0].BalanceMonth > 0) {
            this.tatal_advancement = response.data[0].TatalAdvancement
            // this.balance = this.$formatNumberCurrency(response.data[0].BalanceMonth)
            this.CharsData(response.data[0])
          } else {
            // this.balance = this.$formatNumberCurrency(0)
            this.metricAmount = 0
            this.metricType = ''
            this.tatal_advancement = 0
            this.CharsData('')
          }
        }
      } catch (error) {
        this.balance = 0
        this.showError('No se pudieron obtener el Balance intentalo mas tarde.')
      }
    },
    onChange (value) {
      this.month = value.value
      this.TotalMonth()
    },
    CharsData (indicators) {
      if (indicators !== '') {
        this.nodata = false
        this.tatal_advancement_give = indicators.AdvancementGive
        this.balance = indicators.PayPagado
        this.totalCancel = indicators.AdvancementCancelado
        if (this.metricType === 'Comisión' && this.metricAmount > 0) {
          this.progress = indicators.PayFeeLiquidado
          this.tatal_compare = (indicators.PayFeeLiquidado / this.metricAmount) * 100
        } else if (this.metricAmount > 0) {
          this.progress = indicators.PayLiquidado
          this.tatal_compare = (indicators.PayLiquidado / this.metricAmount) * 100
        } else {
          this.progress = 0
          this.tatal_compare = 0
        }
        const datacharts = [
          {
            id: 1,
            label: 'Cantidad de Adelantos Otorgados',
            sublabel: 'Otorgados',
            compareLavel: 'Cancelado',
            class: '',
            color: '#7654C4',
            description: 'Total de adelantos otorgados.',
            totalStatus: indicators.AdvancementGive,
            balanceStatus: indicators.PayGive,
            totalCompare: this.tatal_advancement
          },
          {
            id: 2,
            label: 'Cantidad de Adelanto Cancelado',
            sublabel: 'Cancelado',
            compareLavel: 'Otorgados',
            class: 'text-danger',
            color: '#ED5A24',
            description: 'Error en la dispersión del adelanto.',
            totalStatus: indicators.AdvancementCancelado,
            balanceStatus: indicators.PayCancelado,
            totalCompare: this.tatal_advancement
          },
          {
            id: 3,
            label: 'Monto de Adelantos Liquidados',
            sublabel: 'Liquidados',
            compareLavel: 'pendientes',
            class: '',
            color: '#7654C4',
            description: 'El empleado liquidó el adelanto.',
            totalStatus: indicators.PayLiquidado,
            balanceStatus: indicators.PayLiquidado,
            totalCompare: indicators.PayLiquidado + indicators.PayPagado
          },
          {
            id: 4,
            label: 'Monto de Saldo pendiente por cobrar',
            sublabel: 'pendientes',
            compareLavel: 'Liquidados',
            class: '',
            color: '#ED5A24',
            description: 'Saldo pendiente por pagar a Adelantazo (Otorgado + comisión + IVA).',
            totalStatus: indicators.PayPagado,
            balanceStatus: indicators.PayPagado,
            totalCompare: indicators.PayLiquidado + indicators.PayPagado
          }
          // {
          //   id: 5,
          //   label: 'Adelantos Aceptados',
          //   class: '',
          //   description: 'Cumple con los requisitos, y es aceptado en espera de ser procesado',
          //   totalStatus: indicators.AdvancementAceptado,
          //   balanceStatus: indicators.PayAceptado
          // },
          // {
          //   id: 6,
          //   label: 'Adelantos Solicitados',
          //   class: '',
          //   description: 'El empleado inicio la solicitud de adelanto, en espera de confirmación.',
          //   totalStatus: indicators.AdvancementSolicitado,
          //   balanceStatus: indicators.PaySolicitado
          // }
        ]
        const datachartsutils = [
          {
            id: 1,
            label: 'Comisión cobrada',
            description: '',
            color: '#7654C4',
            totalStatus: indicators.PayFeeLiquidado,
            comparetotalStatus: indicators.PayFeeAceptada,
            balanceStatus: indicators.PayFeeLiquidado,
            labelChars: 'cobrados'
          },
          {
            id: 2,
            label: 'Comisión pendiente por cobrar',
            description: '',
            color: '#ED5A24',
            totalStatus: indicators.PayFeeAceptada,
            comparetotalStatus: indicators.PayFeeLiquidado,
            balanceStatus: indicators.PayFeeAceptada,
            labelChars: 'No cobrados'
          }
        ]
        this.charts = this.$_.filter(datacharts, charts => charts.totalStatus > 0)
        this.chartsutils = this.$_.filter(datachartsutils, charts => charts.totalStatus > 0)
      } else {
        this.balance = 0
        this.tatal_advancement_give = 0
        this.nodata = true
        this.charts = []
        this.chartsutils = []
      }
    }
  },
  mounted () {
    this.TotalMonth()
  }
}
</script>
